import { Component, OnInit } from '@angular/core';
import { BordereauService } from '../../../bordereau/bordereau.service';
import { NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-sdtk-report',
  templateUrl: './sdtk-report.component.html',
  styleUrls: ['./sdtk-report.component.css']
})
export class SdtkReportComponent implements OnInit {

  constructor(private bordereauService: BordereauService) { }

  // Active tab tracking
  activeTab: string = 'master';

  // Master BDX dates
  masterStartDate: string = '';
  masterEndDate: string = '';

  // Transacted BDX dates
  transactedStartDate: string = '';
  transactedEndDate: string = '';

  // Paid BDX dates
  paidStartDate: string = '';
  paidEndDate: string = '';

  ngOnInit(): void {
  }

  onSubmit(f: NgForm, reportType: string) {
    let data: any = '';
    let startDate: string = '';
    let endDate: string = '';
    let fileName: string = '';

    // Set dates and filename based on report type
    switch (reportType) {
      case 'master':
        startDate = this.masterStartDate;
        endDate = this.masterEndDate;
        fileName = 'master-bdx.xlsx';
        break;
      case 'transacted':
        startDate = this.transactedStartDate;
        endDate = this.transactedEndDate;
        fileName = 'transacted-bdx.xlsx';
        break;
      case 'paid':
        startDate = this.paidStartDate;
        endDate = this.paidEndDate;
        fileName = 'paid-bdx.xlsx';
        break;
    }

    data = {
      start_date: formatDate(startDate, 'yyyy-MM-dd', 'en-US'),
      end_date: formatDate(endDate, 'yyyy-MM-dd', 'en-US'),
      report_type: reportType
    };

    // You may need to update this service call based on your backend implementation
    // If you have different service methods for each report type, you can add them here
    this.bordereauService.policySDTK(data)
      .subscribe(
        (response: any) => {
          var blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        },
        (error) => {
          console.error('Error downloading report:', error);
          // Add error handling as needed
        }
      );
  }
}